module.exports = __webpack_public_path__ + "media/images/arrow_white-b980c1516d3431b4dee26811a796f318.svg";